import { Button, ButtonProps } from "@mui/material";
import { DebounceButton } from "../external/ensolvers-core-frontend-mui/components/Common/DebounceButton";
import { AppSpinner } from "./AppSpinner";
import { Token } from "../theme";

export const ButtonComponent = (
  props: ButtonProps & {
    icon?: JSX.Element;
    text: string;
    onClick: () => void;
    debounce?: boolean;
    inverseIcon?: boolean;
    isLoading?: boolean;
    clearStyles?: boolean;
    outlined?: boolean;
  },
) => {
  const debounceBtnProps = { ...props, icon: undefined, isLoading: false };
  const btnProps = { ...debounceBtnProps, debounce: undefined, text: undefined };

  const getIcon = () => {
    return props.isLoading ? <AppSpinner size={20} /> : props.icon;
  };

  const outlinedStyles = props.outlined
    ? {
        border: `1px solid ${Token.borderDefault}`,
        backgroundColor: Token.surfaceSunken,
        color: Token.textPrimary,
        padding: "6px 12px !important",
        fontSize: "12px",
        minHeight: "32px",
        "&:hover": {
          backgroundColor: Token.surfaceHover,
          borderColor: Token.borderFocus,
        },
      }
    : { fontSize: "12px" };

  return props.debounce ? (
    <DebounceButton
      style={props.clearStyles ? { padding: "0", minWidth: "0" } : {}}
      startIcon={!props.inverseIcon && getIcon()}
      endIcon={props.inverseIcon && getIcon()}
      sx={outlinedStyles}
      {...debounceBtnProps}
    />
  ) : (
    <Button
      style={props.clearStyles ? { padding: "0", minWidth: "0" } : {}}
      startIcon={!props.inverseIcon && getIcon()}
      endIcon={props.inverseIcon && getIcon()}
      sx={outlinedStyles}
      {...btnProps}
    >
      {props.text}
    </Button>
  );
};
